import {Component, computed, inject, OnInit, signal} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {ELearningService} from '../../../../core/services/e-learning.service';
import {ToastrService} from 'ngx-toastr';
import {FuseConfigService} from '../../../../core/services/config.service';
import {NgxSpinnerService} from 'ngx-spinner';
import {DocumentsService} from '../../../../core/services/documents.service';
import moment from 'moment';
import {LearnCategoryService} from '../../../../core/services/learnCategory.service';
import {SpaceService} from '../../../../core/services/space.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {TranslateService} from '@ngx-translate/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {OrganizationsService} from '../../../../core/services/organizations.service';
import { FuseDeleteDialogComponent } from '../../../../core/components/delete-dialog/delete-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import {PlatformsService} from '../../../../core/services/platforms.service';
import {LevelService} from '../../../../core/services/level.service';
import {Subscription} from 'rxjs';
import {distinctUntilChanged} from 'rxjs/operators';
import {CompetencyService} from '../../../../core/services/competency.service';
import {ForumTalkService} from '../../../../core/services/forumTalk.service';
import {EventsService} from '../../../../core/services/events.service';
import {environment} from '../../../../../environments/environment';
import {CertificateTemplateService} from '../../../../core/services/certificateTemplate.service';
import {CertificateSetting} from '../../../../core/components/certificate-setting/certificate-setting.component';

@Component({
    selector: 'el-detail',
    templateUrl: './el-detail.component.html',
    styleUrls: ['./el-detail.component.scss'],
    standalone: false,
    providers: [CompetencyService]
})

export class ElDetailComponent implements OnInit {
  private forumTalkService = inject(ForumTalkService);
  private eventService = inject(EventsService);
  private certificateTemplateService = inject(CertificateTemplateService);
  public editorContent = ``;
  id;
  title;
  html;
  picture;
  userId;
  savedPicture;
  documents: any;
  uploadedDocuments: any;
  pictures: any;
  uploadedPictures: any;
  videos: any;
  uploadedVideos: any;
  public expandAllTabs = true;

  public infoTabOpen = false;
  public mediaTabOpen = false;
  public datesTabOpen = false;
  public categoryTabOpen = false;

  public publishStart;
  public publishEnd;
  public publishStartTime;
  public publishEndTime;
  minEndDate;

  learnCategories = [];
  spaces = [];
  chosenCategories;
  chosenBoards;
  questions = [];

  formGroup = new FormGroup({
    countryId: new FormControl('', Validators.required),
    cityId: new FormControl('', Validators.required),
    organizationId: new FormControl('', Validators.required),
    eventLevel: new FormControl([]),
    skills: new FormControl([]),
  });
  countries = [];
  cities = [];
  organizations = [];
  public = false;
  showOnHome = false;

  elearning;
  platformId;
  platforms;
  selectedPlatforms = [];
  showLevel = false;
  eventLevels = [];
  competencies = [];
  chatSetting = null;

  public subscription = new Subscription();
  forumChatEnabled = this.forumTalkService.forumChatEnabled;
  certificateEnabled = this.certificateTemplateService.certificateEnabled;
  certificateData = signal<CertificateSetting>({certificateAllowed: false, certificateTemplateId: null});
  certificateInvalid = computed(() => this.certificateData().certificateAllowed && !this.certificateData().certificateTemplateId);

  constructor(public elService: ELearningService, public route: ActivatedRoute,
              public toastr: ToastrService, public learnCategoryService: LearnCategoryService,
              public organizationsService: OrganizationsService,
              public spaceService: SpaceService, private snackBar: MatSnackBar,
              private translate: TranslateService,
              private documentService: DocumentsService,
              private router: Router,
              private fuseConfig: FuseConfigService, private spinner: NgxSpinnerService,
              public dialog: MatDialog, private platformsService: PlatformsService, public eventLevel: LevelService,
              public competencyService: CompetencyService) {
    this.id = this.route.snapshot.queryParamMap.get('id');
    this.subscription.add(this.fuseConfig.userId.subscribe((res: any) => {
      if (res) {
        this.userId = res;
      }
    }));
    this.subscription.add(this.fuseConfig.selectedPlatform.subscribe(res => {
      if (res && res.id) {
        this.platformId = res.id;
        // CHANGE FOR MORE PLATFORMS!
        this.showLevel = +this.platformId === 6;
        if (this.showLevel) {
          this.formGroup.patchValue({eventLevel: []});
          this.checkEventLevel();
          this.checkCompetencies();
        }
      }
    }));
    this.subscription.add(this.fuseConfig.role.subscribe(res => {
      const selectControlCountry = this.formGroup.get('countryId');
      const selectControlCanton = this.formGroup.get('cityId');
      const selectControlOrganization = this.formGroup.get('organizationId');
      if (res === 'organisationAdmin') {
        selectControlCountry.disable({emitEvent: false});
        selectControlCanton.disable({emitEvent: false});
        selectControlOrganization.disable({emitEvent: false});
      }
    }));
  }

  ngOnInit() {
    this.getLearnCategories();
    this.getSpaces();
    this.getLevel();
    if (this.id) {
      this.getDetail();
    } else {
      this.init();
    }
  }

  init() {
    this.subscription.add(this.formGroup.get('countryId').valueChanges.pipe(distinctUntilChanged()).subscribe((res) => {
      if (res) {
        this.organizationsService.getCity(res).subscribe((result: any) => {
          this.cities = result;
          this.formGroup.patchValue({cityId: null});
          if (this.elearning) {
            this.formGroup.patchValue({cityId: this.elearning.cityId});
          }
          if (this.cities.length === 1 && !this.elearning){
            this.formGroup.patchValue({cityId: this.cities[0].id});
          }
        });
      }
    }));
    this.subscription.add(this.formGroup.get('cityId').valueChanges.pipe(distinctUntilChanged()).subscribe((res) => {
      if (res) {
        this.organizationsService.getOrganizationByCity(res).subscribe((result: any) => {
          this.organizations = result;
          this.formGroup.patchValue({organizationId: null});
          if (this.elearning) {
            this.formGroup.patchValue({organizationId: this.elearning.organizationId});
          }
          if (this.organizations.length === 1 && !this.elearning){
            this.formGroup.patchValue({organizationId: this.organizations[0].id});
          }
        });
      }
    }));
    this.subscription.add(this.formGroup.get('organizationId').valueChanges.pipe(distinctUntilChanged()).subscribe((res) => {
      this.selectedPlatforms = [];
      if (res) {
        this.platformsService.getByOrganizationId(res).subscribe(platforms => {
          this.platforms = platforms;
          // CHANGE FOR MORE PLATFORMS!
          this.showLevel = (this.platforms.length === 1 && this.platforms[0].id === 6) || +this.platformId === 6;
          if (this.platforms.length === 1) {
            this.selectedPlatforms = [this.platforms[0].id];
          }
          this.checkPlatform();
        });
        this.getCompetenciesByOrganization(res);
      }
    }));
    this.subscription.add(this.organizationsService.getCountry().subscribe((result: any) => {
      this.countries = result;
      if (this.elearning) {
        this.formGroup.patchValue({countryId: this.elearning.countryId});
      }
      if (this.countries.length === 1 && !this.elearning){
        this.formGroup.patchValue({countryId: this.countries[0].id});
      }
    }));
  }

  changePlatforms(platform) {
    this.selectedPlatforms = platform.value;
    this.checkAllowedPlatforms();
    if (this.showLevel) {
      this.formGroup.patchValue({eventLevel: []});
    }
  }

  checkCompetencies() {
    if (this.competencies && this.elearning?.elearningSkills) {
      let array = this.elearning?.elearningSkills.map(item => item.skillId);
      this.formGroup.patchValue({skills: array});
    }
  }

  getCompetenciesByOrganization(id) {
    this.competencyService.competenciesByOrganization(id).subscribe((res: any) => {
      this.competencies = res;
      if (this.elearning?.elearningSkills) {
        this.checkCompetencies();
      }
    });
  }

  checkAllowedPlatforms() {
    // CHANGE FOR MORE PLATFORMS!
    let allowedPlatform = [6];
    if (!this.platformId) {
      this.showLevel = this.selectedPlatforms.length > 0 && this.selectedPlatforms.every(el => allowedPlatform.includes(el));
    }
  }

  checkEventLevel() {
    if (this.eventLevels && this.elearning?.elearningEventLevels) {
      let array = this.elearning?.elearningEventLevels.map(item => item.eventLevelId);
      this.formGroup.patchValue({eventLevel: array});
    }
  }

  checkPlatform() {
    if (this.platforms && this.elearning?.elearningPlatforms) {
      this.selectedPlatforms = this.elearning?.elearningPlatforms.map(item => item.platformId);
      this.checkAllowedPlatforms();
      this.getLevel();
    } else if (!this.elearning && this.platformId) {
      this.selectedPlatforms.push(+this.platformId);
    }
  }

  getLevel() {
    this.eventLevel.getLevels().then((result: any) => {
      this.eventLevels = result.map((res: any) => {
        return {label: res.status ? (res.level + ' / ' + res.status) : res.level  , value: res.id};
      });
      if (this.elearning && this.elearning.elearningEventLevels) {
        this.checkEventLevel();
      }
    });
  }
  getLearnCategories() {
    this.learnCategoryService.getLearnCategories().subscribe((res: any) => {
      if (res) {
       this.learnCategories = res;
      }
    });
  }

  getSpaces(){
    this.spaceService.getSpaceBoards().subscribe((res: any) => {
      if (res) {
        this.spaces = res.spaces;
      }
    });
  }

  changeCategory(value) {
    this.chosenCategories = value.value;
  }

  changeBoards(value) {
    this.chosenBoards = value.value;
  }

  getDetail() {
    this.spinner.show();
    this.elService.getELearningById(this.id).subscribe((res: any) => {
      if (res) {
        if (res.onlyPreview) {
          this.router.navigate([ './pages/eLearning/preview' ], { queryParams: { id: this.id } });
          return;
        }
        this.title = res.title;
        this.editorContent = res.description;
        this.public = res.public;
        this.showOnHome = res.showOnHome;
        this.id = res.id;
        this.userId = res.userId;
        this.savedPicture = res.picture;
        this.uploadedDocuments = res.documents;
        this.uploadedVideos = res.videos;
        this.uploadedPictures = res.pictures;
        this.publishStart = (res.publishStart ? new Date(res.publishStart) : null);
        this.publishEnd = (res.publishEnd ? new Date(res.publishEnd) : null);
        this.publishStartTime = (res.publishStartTime ? moment(res.publishStart).format('HH:mm') : null);
        this.publishEndTime = (res.publishEndTime ? moment(res.publishEnd).format('HH:mm') : null);
        this.chatSetting = res.chatSetting;
        this.certificateData.set({
          certificateAllowed: res.certificateAllowed ?? false,
          certificateTemplateId: res.certificateTemplateId ?? null
        });
        if (this.publishStart) {
          this.minEndDate = this.publishStart;
        }
        if (res.learnCategories) {
          let cat = res.learnCategories.split(',');
          this.chosenCategories = cat.map(el => Number(el.replace(/\//g, '')));
        }
        if (res.boards) {
          let boards = res.boards.split(',');
          this.chosenBoards = boards.map(el => Number(el.replace(/\//g, '')));
        }
        if (res.questions) {
          this.questions = JSON.parse(this.elService.atobUtf8(res.questions));
          if (!this.questions) {
            this.questions = [];
          }
        }
        this.elearning = res;
        this.checkEventLevel();
        this.checkCompetencies();
        this.init();
      }
      this.spinner.hide();
    });
  }

  uploadDocuments(documents) {
    this.documents = documents;
  }

  uploadPictures(pictures) {
    this.pictures = pictures;
  }

  uploadVideo(videos) {
    this.videos = videos;
  }

  setImg(image) {
    this.picture = image;
  }

  addELearning() {
    if (this.certificateInvalid()) {
      return;
    }
    this.spinner.show();
    let data: any = {
      title: this.title,
      description: this.editorContent,
      userId: this.userId,
      public: this.public,
      showOnHome: this.showOnHome,
      ...this.certificateData(),
      platforms: ''
    };
    data = Object.assign(data, this.formGroup.getRawValue());
    if (this.selectedPlatforms.length) {
      data.platforms = this.selectedPlatforms.join(',');
    }
    if (this.platformId) {
      data.platforms = this.platformId;
    }
    if (!this.showLevel) {
      data.eventLevel = '';
      data.skills = '';
    }
    if (this.id) {
      data.id = this.id;
    }
    if (this.savedPicture) {
      data.picture = this.savedPicture;
    }
    if (this.picture) {
      data.file = this.picture;
    }
    if (this.chatSetting) {
      let _chatSetting = {...this.chatSetting};
      delete _chatSetting.room_avatar_file;
      data.chatSetting = JSON.stringify(_chatSetting);
    }
    if (this.questions && this.questions.length) {
      let error = {type: ''};
      for (let i = 0; i < this.questions.length; i++) {
        if (!this.questions[i].title) {
          error.type = 'no-title';
          break;
        }
        if (this.questions[i].type === 'single' || this.questions[i].type === 'multiple') {
          if (!this.questions[i].answers.length) {
            error.type = 'no-answers';
            break;
          } else {
            let emptyIndex = this.questions[i].answers.findIndex(el => !el.text);
            if (emptyIndex !== -1) {
              error.type = 'no-answers-text';
              break;
            }
          }
        }
      }
      if (error.type) {
        let errorText = this.translate.instant(error.type);
        let title = this.translate.instant('failure');
        this.toastr.error(errorText, title);
        this.spinner.hide();
        return;
      } else {
        data.questions = JSON.stringify(this.questions);
      }
    } else {
      data.questions = JSON.stringify(this.questions);
    }
    data.publishStart = this.publishStart;
    data.publishEnd = this.publishEnd;
    data.publishStartTime = this.publishStartTime;
    data.publishEndTime = this.publishEndTime;
    if (this.chosenCategories && this.chosenCategories.length) {
      let categories = this.chosenCategories.map(el => '/' + el.toString() + '/');
      data.learnCategories = categories;
    }
    if (this.chosenBoards && this.chosenBoards.length) {
      let boards = this.chosenBoards.map(el => '/' + el.toString() + '/');
      data.boards = boards;
    } else {
      let errorText = this.translate.instant('choose_board_error');
      let title = this.translate.instant('failure');
      this.toastr.error(errorText, title);
      this.spinner.hide();
      return;
    }
    this.elService.addELearnings(data).subscribe((res: any) => {
      if (this.chatSetting?.status && this.chatSetting?.room_avatar_file) {
        this.eventService.saveRoomAvatar(res.id, this.chatSetting.room_avatar_file, 'elearningId').subscribe();
      }
      if (this.documents && this.documents.length) {
        let documentData = {files: this.documents , type: 'elearning' , connectedId: res.id};
        this.documentService.uploadElDocument(documentData).subscribe((resDoc) => {
        });
      }
      if (this.pictures && this.pictures.length) {
        let documentData = {files: this.pictures , type: 'elearning-picture' , connectedId: res.id};
        this.documentService.uploadElDocument(documentData).subscribe((resDoc) => {
        });
      }
      if (this.videos && this.videos.length) {
        for (let video of this.videos) {
          video.connectedId = res.id;
        }
        this.documentService.addBigDocument(this.videos).subscribe((resDoc) => {
        });
      }
      this.toastr.success('ELearning added', 'Success!');
      this.spinner.hide();
      this.router.navigate([ './pages/eLearning' ]);
    });
  }

  expandAll () {
    this.expandAllTabs = !this.expandAllTabs;
  }

  changeEndPublish(event) {
    if (!this.publishEndTime) {
      let date = new Date(event);
      date.setHours(20);
      event = date;
      this.publishEndTime = '20:00';
    } else {
      let date = new Date(event);
      let timeArr = this.publishEndTime.split(':');
      date.setHours(+timeArr[0]);
      date.setMinutes(+timeArr[1]);
      event = date;
    }
    this.publishEnd = event;
  }
  changeStartPublish(event) {
    if (!this.publishStartTime) {
      let date = new Date(event);
      date.setHours(7);
      event = date;
      this.publishStartTime = '07:00';
    } else {
      let date = new Date(event);
      let timeArr = this.publishStartTime.split(':');
      date.setHours(+timeArr[0]);
      date.setMinutes(+timeArr[1]);
      event = date;
    }
    this.publishStart = event;
    this.minEndDate = event;
  }

  closePicker(event, data) {
    let res = data;
    if (res) {
      if (event === 'publishStart') {
        this.publishStartTime = res;
        if (this.publishStart) {
          let date = new Date(this.publishStart);
          let timeArr = this.publishStartTime.split(':');
          date.setHours(+timeArr[0]);
          date.setMinutes(+timeArr[1]);
          this.publishStart = date;
        }
      }
      if (event === 'publishEnd') {
        this.publishEndTime = res;
        if (this.publishEnd) {
          let date = new Date(this.publishEnd);
          let timeArr = this.publishEndTime.split(':');
          date.setHours(+timeArr[0]);
          date.setMinutes(+timeArr[1]);
          this.publishEnd = date;
        }
      }
    }
  }

  addQuestion() {
    let id = Date.now().toString(36) + Math.random().toString(36).substr(2);
    this.questions.push({
      title: '',
      type: 'text',
      id: id,
      answers: [],
      correctAnswer: ''
    });
  }

  addAnswer(id) {
    let answerId = 'answer_' + Date.now().toString(36) + Math.random().toString(36).substr(2);
    let index = this.questions.findIndex(el => el.id === id);
    if (index !== -1) {
      this.questions[index].answers.push({
        id: answerId,
        text: '',
        isCorrect: false
      });
    }
  }

  removeQuestion(id){
    let index = this.questions.findIndex(el => el.id === id);
    if (index !== -1) {
      this.questions.splice(index, 1);
    }
  }

  removeAnswer(questionId, answerId) {
    let index = this.questions.findIndex(el => el.id === questionId);
    if (index !== -1) {
      let answerIndex = this.questions[index].answers.findIndex(el => el.id === answerId);
      if (answerIndex !== -1) {
        this.questions[index].answers.splice(answerIndex, 1);
      }
    }
  }

  deleteELearning() {
    const dialogRef = this.dialog.open(FuseDeleteDialogComponent , { panelClass: 'unsave-form-dialog',
      width: '300px' ,
      data: {title: 'Delete' , message: 'deleteConfirm'}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.elService.deleteELearnings(this.id).subscribe((res) => {
          this.toastr.success('Elearning deleted', 'Success!');
          this.router.navigate([ './pages/eLearning' ]);
        });
      }
    });
  }

  onChatFormResult(e) {
    this.chatSetting = e;
  }

  onCertificateFormResult(e: CertificateSetting) {
    this.certificateData.set(e);
  }

  openChat() {
    window.open(`${environment.frontChatUrl}/external-link?roomId=${encodeURIComponent(this.elearning.goToChatId)}&email=${encodeURIComponent(this.elearning.goToChatEmail)}`, '_blank');
  }
}
